import { NavigationContext } from '@layout/navigation/navigation';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';
import { toMap } from '@pages/Products/components/OnBoardingModal/OnBoardingModal.utils';
import { manualAddConfirm } from '@services/mixpanel/trackers/ManualAdd';
import { createEquipments } from '@services/queries/equipments';
import { EQUIPMENTS_PICKER_SEND_TYPE } from '@store/machines/equipmentsPicker';
import {
  addKnownEquipments,
  EqRet,
} from '@store/redux/features/inventory/knownData';
import { useAppDispatch, useAppSelector } from '@store/redux/store';
import { getProductAmount } from '@utils';
import { useContext } from 'react';
import { useMutation } from 'react-query';
import {
  BodySelect,
  Bottom,
  BottomButton,
  ButtonRow,
  WhiteBottomButton,
} from '../components.styles';
import { ListEquipmentsWithQuantity } from './components';

interface OwnProps {
  products: ProductRequest[];
  returnBody: () => void;
  nextBody: () => void;
  refreshProducts: any;
  onClose: () => void;
  send: EQUIPMENTS_PICKER_SEND_TYPE;
  updateDataSelected: (products?: ProductRequest[]) => void;
}

export const QuantityBody = ({
  products,
  returnBody,
  nextBody,
  onClose,
  refreshProducts,
  send,
  updateDataSelected,
}: OwnProps) => {
  const { userConfiguration } = useAppSelector();
  const dispatch = useAppDispatch();

  const { studioName } = useContext(NavigationContext);

  const mutationCreateEquipments = useMutation(createEquipments, {
    onSuccess: equipments => {
      if (userConfiguration.onBoardingDontShowAgain) {
        if (userConfiguration.startOnBoarding) {
          // Tags are the only place truly different between IEquipmentInventory and this.
          onClose();
          send({
            type: 'LAUNCH',
            data: toMap(equipments as EqRet[]),
            modalName: 'MASS_EDIT',
          });

          return;
        }
        refreshProducts('');
        onClose();

        manualAddConfirm(studioName, equipments.length);

        return;
      }
      dispatch(addKnownEquipments(equipments as EqRet[]));

      refreshProducts('');
      nextBody();
    },
  });
  const onConfirm = () => {
    const result = getProductAmount(products);
    mutationCreateEquipments.mutate({
      amountProducts: result,
    });
  };
  return (
    <>
      <BodySelect>
        <ListEquipmentsWithQuantity
          dataSelected={products}
          updateDataSelected={updateDataSelected}
          returnBody={returnBody}
        />
      </BodySelect>
      <Bottom>
        <ButtonRow />
        <ButtonRow>
          <WhiteBottomButton onClick={returnBody}>Return</WhiteBottomButton>
          <BottomButton onClick={onConfirm}>Confirm</BottomButton>
        </ButtonRow>
      </Bottom>
    </>
  );
};
